module.exports = __webpack_public_path__ + "static/media/survey.84d30cbb.svg";